export default __webpack_public_path__ + "static/media/Image3.fcc5e6d1.jpg";